import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ProfileBenefit } from '../profile-benefit.model';
import { BenefitService } from '../benefit.service';
import { BenefitType } from '../benefit-type.model';

@Component({
  selector: 'wl-benefit-add',
  templateUrl: 'benefit-add.component.html',
  //providers: [BenefitService, ProfileService]
    standalone: false
})
export class BenefitAddComponent implements OnInit {
  public _benefitService: BenefitService;

  @Input('benefit') benefit: ProfileBenefit;
  @Input('createMode') createMode: boolean;
  @Input('useDuesBillingDate') useDuesBillingDate: boolean;
  @Output() useDuesBillingDateChange = new EventEmitter();
  public benefitTypes: Array<BenefitType>;
  public availableBenefitTypes: Array<BenefitType>;

  public constructor(benefitService: BenefitService) {
    this._benefitService = benefitService;
    this.benefitTypes = new Array<BenefitType>();
    this.createMode = false;
    this.useDuesBillingDate = false;
  }

  ngOnInit() {
    this._benefitService.getBenefitTypes().then((data: Array<BenefitType>) => {
      // keep these so we always have the types
      this.benefitTypes = data;
      // these are the types that are visible depending on the existing types from the member.
      this.availableBenefitTypes = data;
    });
  }

  // Set the existing benefit types so they don't get displayed for the user. This is more efficient than a binding since we don't want to continuously chew cycles for the end user.
  public setExistingBenefitTypes = (existingBenefitTypes: Array<number>) => {
    this.availableBenefitTypes = this.benefitTypes.filter(
      x => x.Id == this.benefit.BenefitTypeId || existingBenefitTypes.indexOf(x.Id) < 0
    );
  };

  public onBenefitTypeChange = (data: string): void => {
    if (data != '0') {
      //the option comes thru as a string convert to int
      this.benefit.BenefitTypeId = parseInt(data);
      let benefit = this.availableBenefitTypes.find(x => x.Id == this.benefit.BenefitTypeId);
      this.benefit.Value = benefit.Value;
    }
  };

  public handleQuantityUsedChanged = (): void => {
    this.benefit.ValueUsed = this.benefit.QuantityUsed * this.benefit.Value;
  };

  public onExpirationDateUseChanged = (status: boolean) => {
    this.useDuesBillingDateChange.emit(status);
  };
}
